/**
 * Eén stijl bij een tekst in het tabblad Illustraties: het plaatje als het
 * er is (met het aantal pogingen, opnieuw maken en verwijderen), anders een
 * knop Genereer.
 *
 * Opnieuw maken vraagt eerst wat er anders moet; die aanwijzing gaat mee
 * naar het beeldmodel. Leeg laten mag ook.
 */
import React, { useState } from 'react';
import { Image, Palette, RefreshCw, Sparkles, Trash2 } from 'lucide-react';

// Per stijl: de naam op de kaart, de uitleg, en de kleur van rand en icoon.
export const STIJLEN = [
  { stijl: 'lijntekening', titel: 'Lijntekening', uitleg: 'Zwart-wit, fijne arcering', kleur: 'var(--inkt)', vlak: 'var(--vlak-3)',
    alt: 'Lijntekening', aanwijzing: "Wat moet anders? (bijv. 'meer details in de achtergrond')" },
  { stijl: 'foto', titel: 'Realistische Foto', uitleg: 'Fotorealistisch, gedetailleerd', kleur: 'var(--blauw)', vlak: 'var(--blauw-vlak-4)',
    alt: 'Foto', aanwijzing: 'Wat moet anders?' },
  { stijl: 'schattig', titel: 'Schattige Tekening', uitleg: 'Kindvriendelijk, aquarel', kleur: 'var(--fout-2)', vlak: 'var(--fout-vlak-3)',
    alt: 'Schattig', aanwijzing: 'Wat moet anders?' },
];

export function IllustratieKaart({ soort, illustratie, beeld, bezig, onMaak, onVerwijder }) {
  const [vraagAanwijzing, setVraagAanwijzing] = useState(false);
  const [aanwijzing, setAanwijzing] = useState('');

  const maakOpnieuw = async () => {
    const gelukt = await onMaak(aanwijzing);
    if (gelukt) {
      setAanwijzing('');
      setVraagAanwijzing(false);
    }
  };

  return (
    <div className="card" style={{ background: 'var(--wit)' }}>
      <div style={{ textAlign: 'center', marginBottom: 12 }}>
        <Palette size={24} style={{ color: soort.kleur }} />
        <h4>{soort.titel}</h4>
        <p className="text-muted text-small">{soort.uitleg}</p>
      </div>

      {!illustratie ? (
        <button className="btn btn-primary" onClick={() => onMaak(null)} disabled={bezig} style={{ width: '100%', padding: '12px' }}>
          {bezig ? <><RefreshCw size={14} className="spinning" /> Genereren...</> : <><Sparkles size={14} /> Genereer</>}
        </button>
      ) : (
        <>
          <div style={{
            width: '100%',
            height: 180,
            background: soort.vlak,
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `2px solid ${soort.kleur}`,
          }}>
            {illustratie.has_image && beeld ? (
              <img src={beeld} alt={soort.alt} style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: 4 }} />
            ) : illustratie.has_image ? (
              <RefreshCw size={24} className="spinning" style={{ color: soort.kleur }} />
            ) : (
              <Image size={48} style={{ color: soort.kleur }} />
            )}
          </div>
          <p className="text-muted text-small mt-8">Generaties: {illustratie.generation_count || 1}</p>

          {vraagAanwijzing ? (
            <div className="mt-8">
              <input type="text" className="input" placeholder={soort.aanwijzing} value={aanwijzing}
                onChange={e => setAanwijzing(e.target.value)} />
              <div className="flex gap-8 mt-8">
                <button className="btn btn-primary" onClick={maakOpnieuw} disabled={bezig} style={{ flex: 1 }}>
                  <RefreshCw size={14} className={bezig ? 'spinning' : undefined} /> Opnieuw
                </button>
                <button className="btn btn-secondary" onClick={() => setVraagAanwijzing(false)}>Annuleer</button>
              </div>
            </div>
          ) : (
            <div className="flex gap-8 mt-8">
              <button className="btn btn-secondary" onClick={() => setVraagAanwijzing(true)} style={{ flex: 1, padding: '6px 12px', fontSize: 13 }}>
                <RefreshCw size={12} /> Opnieuw maken
              </button>
              <button className="btn btn-danger" onClick={onVerwijder} style={{ padding: '6px 12px', fontSize: 13 }}>
                <Trash2 size={12} />
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
